import boletaApi from "./boletaApi";

export const newInvoiceRequest = async (body) => {
  try {
    return await boletaApi.post("/newInvoiceRequest", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
